import React from 'react'
import { useSelector } from 'react-redux'
import { selectCountryForLocale } from '../../store/navigation/navigation.selectors'
import { selectCitiesToDiscoverLinks } from '../../store/seo/seo.selectors'
import { withoutEnglishSite } from '../i18n/i18nSite'
import { useT } from '../i18n/T'
import { IntroductionWithLinks } from '../genericComponents/Introduction'

export const CitiesToDiscover = () => {
  const country = useSelector(selectCountryForLocale)
  const citiesToDiscoverLinks = useSelector(selectCitiesToDiscoverLinks)
  return (
    <IntroductionWithLinks
      h1={useT('home.discoverCities.h1', country)}
      h2={useT('home.discoverCities.h2', country)}
      links={citiesToDiscoverLinks}
    />
  )
}

export default withoutEnglishSite(CitiesToDiscover)
